export const actionTypes = {
  GET_PROFILE: 'GET_PROFILE',
  GET_PROFILE_SUCCESS: 'GET_PROFILE_SUCCESS',
  GET_PROFILE_FAIL: 'GET_PROFILE_FAIL',

  UPDATE_PROFILE: 'UPDATE_PROFILE',
  UPDATE_PROFILE_SUCCESS: 'UPDATE_PROFILE_SUCCESS',
  UPDATE_PROFILE_FAIL: 'UPDATE_PROFILE_FAIL',
  CLEAR_ERROR_CHANGE_PROFILE: 'CLEAR_ERROR_CHANGE_PROFILE',

  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAIL: 'CHANGE_PASSWORD_FAIL',

  CONFIRM_SUBCRIPTION: 'CONFIRM_SUBCRIPTION',
  CONFIRM_SUBCRIPTION_SUCCESS: 'CONFIRM_SUBCRIPTION_SUCCESS',
  CONFIRM_SUBCRIPTION_FAIL: 'CONFIRM_SUBCRIPTION_FAIL',

  SETUP_STRIPE: 'SETUP_STRIPE',
  SETUP_STRIPE_SUCCESS: 'SETUP_STRIPE_SUCCESS',
  SETUP_STRIPE_FAIL: 'SETUP_STRIPE_FAIL',

  STRIPE_CONNECT_ONBOARDING_START: 'STRIPE_CONNECT_ONBOARDING_START',
  STRIPE_CONNECT_ONBOARDING_END: 'STRIPE_CONNECT_ONBOARDING_END',

  CANCEL_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
  CANCEL_SUBSCRIPTION_SUCCESS: 'CANCEL_SUBSCRIPTION_SUCCESS',
  CANCEL_SUBSCRIPTION_FAIL: 'CANCEL_SUBSCRIPTION_FAIL',

  SUBSCRIPTION_STRIPE: 'SUBSCRIPTION_STRIPE',
  SUBSCRIPTION_STRIPE_SUCCESS: 'SUBSCRIPTION_STRIPE_SUCCESS',
  SUBSCRIPTION_STRIPE_FAIL: 'SUBSCRIPTION_STRIPE_FAIL',

  CLEAR_LOADING_LOGIN: 'CLEAR_LOADING_LOGIN',

  REFRESH_TOKEN: 'REFRESH_TOKEN',
  REFRESH_TOKEN_SUCCESS: 'REFRESH_TOKEN_SUCCESS',

  SEND_SUPPORT_EMAIL: 'SEND_SUPPORT_EMAIL',
  SEND_SUPPORT_EMAIL_SUCCESS: 'SEND_SUPPORT_EMAIL_SUCCESS',
  SEND_SUPPORT_EMAIL_FAIL: 'SEND_SUPPORT_EMAIL_FAIL',

  DEPLOY_APP: 'DEPLOY_APP',
  DEPLOY_APP_SUCCESS: 'DEPLOY_APP_SUCCESS',
  DEPLOY_APP_FAIL: 'DEPLOY_APP_FAIL',
};

export const actions = {
  deployApp: () => ({
    type: actionTypes.DEPLOY_APP,
  }),
  deployAppSuccess: (data: unknown) => ({
    type: actionTypes.DEPLOY_APP_SUCCESS,
    payload: data,
  }),
  deployAppFail: (err: unknown) => ({
    type: actionTypes.DEPLOY_APP_FAIL,
    payload: err,
  }),

  sendSupportEmail: () => ({
    type: actionTypes.SEND_SUPPORT_EMAIL,
  }),
  sendSupportEmailSuccess: () => ({
    type: actionTypes.SEND_SUPPORT_EMAIL_SUCCESS,
  }),
  sendSupportEmailFail: (err: unknown) => ({
    type: actionTypes.SEND_SUPPORT_EMAIL_FAIL,
    payload: err,
  }),

  getProfile: () => ({
    type: actionTypes.GET_PROFILE,
  }),
  getProfileSuccess: (data: unknown) => ({
    type: actionTypes.GET_PROFILE_SUCCESS,
    payload: data,
  }),
  getProfileFail: (err: unknown) => ({
    type: actionTypes.GET_PROFILE_FAIL,
    payload: err,
  }),

  updateProfile: () => ({
    type: actionTypes.UPDATE_PROFILE,
  }),
  updateProfileSuccess: (data: unknown) => ({
    type: actionTypes.UPDATE_PROFILE_SUCCESS,
    payload: data,
  }),
  updateProfileFail: (err: unknown) => ({
    type: actionTypes.UPDATE_PROFILE_FAIL,
    payload: err,
  }),

  changePassword: () => ({
    type: actionTypes.CHANGE_PASSWORD,
  }),
  changePasswordSuccess: (data: unknown) => ({
    type: actionTypes.CHANGE_PASSWORD_SUCCESS,
    payload: data,
  }),
  changePasswordFail: (err: unknown) => ({
    type: actionTypes.CHANGE_PASSWORD_FAIL,
    payload: err,
  }),

  confirmSubcription: () => ({
    type: actionTypes.CONFIRM_SUBCRIPTION,
  }),
  confirmSubcriptionSuccess: () => ({
    type: actionTypes.CONFIRM_SUBCRIPTION_SUCCESS,
  }),
  confirmSubcriptionFail: () => ({
    type: actionTypes.CONFIRM_SUBCRIPTION_FAIL,
  }),

  setupStripe: () => ({
    type: actionTypes.SETUP_STRIPE,
  }),
  setupStripeSuccess: () => ({
    type: actionTypes.SETUP_STRIPE_SUCCESS,
  }),
  setupStripeFail: (err: unknown) => ({
    type: actionTypes.SETUP_STRIPE_FAIL,
  }),

  stripeConnectOnboardingStart: () => ({
    type: actionTypes.STRIPE_CONNECT_ONBOARDING_START,
  }),
  stripeConnectOnboardingEnd: () => ({
    type: actionTypes.STRIPE_CONNECT_ONBOARDING_END,
  }),

  cancelSubscription: () => ({
    type: actionTypes.CANCEL_SUBSCRIPTION,
  }),
  cancelSubscriptionSuccess: () => ({
    type: actionTypes.CANCEL_SUBSCRIPTION_SUCCESS,
  }),
  cancelSubscriptionFail: (err: unknown) => ({
    type: actionTypes.CANCEL_SUBSCRIPTION_FAIL,
    payload: err,
  }),

  subscriptionStripe: () => ({
    type: actionTypes.SUBSCRIPTION_STRIPE,
  }),
  subscriptionStripeSuccess: () => ({
    type: actionTypes.SUBSCRIPTION_STRIPE_SUCCESS,
  }),
  subscriptionStripeFail: (err: unknown) => ({
    type: actionTypes.SUBSCRIPTION_STRIPE_FAIL,
    payload: err,
  }),

  clearErrorChangeProfile: () => ({
    type: actionTypes.CLEAR_ERROR_CHANGE_PROFILE
  }),

  clearLoadingLogin: () => ({
    type: actionTypes.CLEAR_LOADING_LOGIN
  }),

  refreshToken: () => ({
    type: actionTypes.REFRESH_TOKEN
  }),

  refreshTokenSuccess: (data: unknown) => ({
    type: actionTypes.REFRESH_TOKEN_SUCCESS,
    payload: data
  })
};
